import { InterfaceTransformIcon, Text, Icon } from '@grammarly/design-system'
import cn from 'classnames'
import { FormattedMessage } from 'react-intl'

import { useExperimentService } from '@lib/hooks'
import { useSignUpAction } from '@components/item/cta-button/signup-product-recommendation/hooks/useSignupAction'
import { useTool } from '../tool-context'

import styles from '../tool.module.scss'

export const ToolFooterBanner = () => {
  const { footerBannerCopy } = useTool()
  const { isToolsRedesign2_3AnonEnabled } = useExperimentService()

  const toQueryParam = 'editor'
  const onClick = useSignUpAction({ toQueryParam })

  if (isToolsRedesign2_3AnonEnabled()) {
    return (
      <button onClick={onClick} className={cn(styles.toolFooterBannerContainer, styles.tool2_3FooterBannerContainer)}>
        <Text variant="text-large" as="span" className={styles.tools2_3FooterBannerCopy}>
          {footerBannerCopy}
        </Text>
        <div className={styles.tools2_3FooterBannerButtonContainer}>
          <Text variant="text-large" as="span" className={styles.tools2_3FooterBannerCta}>
            <strong>
              <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
            </strong>
            &nbsp;&nbsp;
            <FormattedMessage id="phrase.itsFree" description="Sign up prompt value prop" defaultMessage="It's free" />
          </Text>
          <Icon icon={InterfaceTransformIcon} accessibilityLabel="" variant="inherit" />
        </div>
      </button>
    )
  }

  return (
    <button onClick={onClick} className={styles.toolFooterBannerContainer}>
      <Text variant="text-large" as="span" color="base-inverse">
        {footerBannerCopy}
      </Text>
      <div className={styles.toolFooterBannerButtonContainer}>
        <Text variant="text-medium" as="span" color="base-default">
          <strong>
            <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
          </strong>
          &nbsp;&nbsp;
          <FormattedMessage id="phrase.itsFree" description="Sign up prompt value prop" defaultMessage="It's free" />
        </Text>
      </div>
    </button>
  )
}
